import React, { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';
import { Stepper } from '@mint-lib/tw-components/patterns';

import FirstStep from './FirstStep.jsx';
import SecondStep from './SecondStep.jsx';
import DialogSubmitBtns from './SubmitButtons.jsx';

type AcceptProps = {
  isLoading: boolean;
  onCloseDialog: () => void;
  onAccept: () => void;
  onAcceptNewVersion: () => void;
};

const Accept = ({
  isLoading,
  onCloseDialog,
  onAccept,
  onAcceptNewVersion,
}: AcceptProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  const [isSure, setIsSure] = useState(false);
  const [dontAskAgain, setDontAskAgain] = useState(false);
  const [step, setStep] = useState(0);

  const steps = [
    {
      title: t('Accept suggestion'),
    },
    {
      title: t('Buying Plan version'),
    },
  ];

  return (
    <Dialog open modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onCloseDialog}>
          <DialogTitle>{t('Accept this suggestion?')}</DialogTitle>
        </DialogHeader>

        <DialogContent className="flex flex-col">
          <div className="mb-6 flex flex-row">
            <Stepper
              steps={steps}
              completedStep={{
                0: step !== 0,
              }}
              activeStep={step}
            />
          </div>

          {step === 0 ? (
            <FirstStep
              isChecked={isSure}
              onChangeCheck={() => setIsSure(!isSure)}
            />
          ) : (
            <SecondStep
              isChecked={dontAskAgain}
              onChangeCheck={() => setDontAskAgain(!dontAskAgain)}
            />
          )}
        </DialogContent>
        <DialogFooter>
          <DialogSubmitBtns
            step={step}
            onNextStep={() => setStep(1)}
            isSure={isSure}
            onAcceptUpdate={onAccept}
            isLoadingAccept={isLoading}
            onAcceptNewCreate={onAcceptNewVersion}
          />
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};

export default Accept;
